<template>
  <sidebar-layout>
    <template #top>
      <status-banner :text="i18n.t('events.show.attending_status_hosting')" icon="icon-home" status="success" />
    </template>

    <sharing-prompt v-if="eventCanBeShared" />
  </sidebar-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import SharingPrompt from '@/campaign-action-shared/sharing-prompt'
import SidebarLayout from '@/campaign-action-shared/sidebar-layout'
import StatusBanner from '@/campaign-action-shared/status-banner'

export default {
  components: { SharingPrompt, SidebarLayout, StatusBanner },

  computed: {
    ...mapGetters(['eventCanBeShared'])
  }
}
</script>
